enum CardType {
  PHYSICAL = "PHYSICAL",
  VIRTUAL = "VIRTUAL",
  EXTERNAL = "EXTERNAL",
}

export default CardType;
